/* Preval Data */
import headerData from '@integrations/preval/headerdata.preval';

import SkuCategories from './SkuCategories';
import { SkuCategoriesProps } from './topNavItems.types';

interface TopNavItemsProps extends SkuCategoriesProps {}

const TopNavItems = (props: TopNavItemsProps) => <SkuCategories {...props} {...headerData} />;

export default TopNavItems;
